







































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class GuideGeneralBookDiagonalShooting extends Vue {
  @Prop({ type: String, required: true })
  public direction!: 'horizontal' | 'vertical';
}
